import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function StickyCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      const waitlist = document.getElementById("waitlist");
      const waitlistTop = waitlist ? waitlist.getBoundingClientRect().top + window.scrollY : Infinity;
      // Show after user scrolls past hero, hide when waitlist is visible
      const show = y > 700 && window.scrollY + window.innerHeight < waitlistTop + 200;
      setVisible(show);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.a
          href="#waitlist"
          data-testid="sticky-cta-btn"
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 30, opacity: 0 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          className="md:hidden fixed bottom-5 left-4 right-4 z-40 inline-flex items-center justify-center gap-2 rounded-full px-5 py-3.5 text-sm font-medium text-ink-900 bg-emerald-400 hover:bg-emerald-300 transition-all glow-emerald"
        >
          Request Beta Access
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M13 5l7 7-7 7"/></svg>
        </motion.a>
      )}
    </AnimatePresence>
  );
}
